/* ------------------------------------------------------------------
 * Magni Premium Bento — mobile tap highlight.
 * The scroll-in entrance now lives in the shared magni-reveal util (the cards
 * carry [data-magni-reveal] so each floats in as it crosses, not all at once).
 * This file only handles the touch-tap highlight on the cards.
 * ------------------------------------------------------------------ */
(function () {
  'use strict';

  function initBento(section) {
    var cards = [].slice.call(section.querySelectorAll('.magni-bento__card'));
    if (!cards.length) return;

    // Mobile tap: briefly highlight the tapped card (mirrors the desktop hover).
    // iOS won't fire :active on a plain <article>, so toggle a class from touch
    // events; the CSS transition handles the fade-out when it's removed.
    cards.forEach(function (c) {
      c.addEventListener('touchstart', function () { c.classList.add('is-pressed'); }, { passive: true });
      function release() {
        // small linger so a quick tap still reads as a highlight before it fades
        window.setTimeout(function () { c.classList.remove('is-pressed'); }, 260);
      }
      c.addEventListener('touchend', release, { passive: true });
      c.addEventListener('touchcancel', release, { passive: true });
    });
  }

  function init() {
    [].slice.call(document.querySelectorAll('[data-magni-bento]')).forEach(initBento);
  }

  // Bind one-time init + the section:load re-init only once (the editor re-runs
  // this in-section script on every reload).
  if (window.MagniBentoBound) return;
  window.MagniBentoBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-magni-bento]');
    if (section) initBento(section);
  });
})();
